import React from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faStar, faEnvelope, faProjectDiagram, faBoxes } from '@fortawesome/free-solid-svg-icons';
import styles from '../Dashboard.module.css';
import overviewStyles from './Overview.module.css';

import DashboardHero from '../../components/dashboard/DashboardHero';
import WeatherWidget from '../../components/widgets/WeatherWidget';

const Overview = () => {
  const { users, reviews, messages, projects, stats } = useOutletContext();
  const navigate = useNavigate();

  return (
    <>
      <DashboardHero />

      <div style={{ marginBottom: '20px' }}>
        <WeatherWidget />
      </div>

      <section id="dashboard-stats" className={styles.statsCards} style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
        <div className={styles.card} style={{ borderLeft: '4px solid #10b981' }}>
          <div className={styles.cardIcon} style={{ color: '#10b981' }}><FontAwesomeIcon icon={faProjectDiagram} /></div>
          <div className={styles.cardInfo}>
            <p>Avancement Moyen</p>
            <span>{stats.averageProgress}%</span>
          </div>
        </div>
        <div className={styles.card} style={{ borderLeft: '4px solid #ef4444' }}>
          <div className={styles.cardIcon} style={{ color: '#ef4444' }}><FontAwesomeIcon icon={faBoxes} /></div>
          <div className={styles.cardInfo}>
            <p>Alertes Stock</p>
            <span>{stats.lowStockCount}</span>
          </div>
        </div>
        <div className={styles.card} style={{ borderLeft: '4px solid #3b82f6' }}>
          <div className={styles.cardIcon} style={{ color: '#3b82f6' }}><FontAwesomeIcon icon={faUsers} /></div>
          <div className={styles.cardInfo}>
            <p>Candidatures</p>
            <span>{stats.pendingApplications}</span>
          </div>
        </div>
        <div className={styles.card} style={{ borderLeft: '4px solid #f59e0b' }}>
          <div className={styles.cardIcon} style={{ color: '#f59e0b' }}><FontAwesomeIcon icon={faEnvelope} /></div>
          <div className={styles.cardInfo}>
            <p>Messages Non Lus</p>
            <span>{stats.unreadMessages}</span>
          </div>
        </div>
      </section>

      <div className={styles.overviewGrid}>
        <section id="overview-projects" className={styles.dataSection}>
          <div className={styles.sectionHeader}>
            <h3>Derniers Projets</h3>
            <button onClick={() => navigate('/admin/projects')} className={styles.viewAllButton}>Voir tout</button>
          </div>
          <ul className={overviewStyles.mobileList}>
            {projects.slice(0, 3).map(project => (
              <li key={project.id} className={overviewStyles.mobileCard}>
                <div className={overviewStyles.cardHeader}>
                  <h4 className={overviewStyles.cardTitle}>{project.title}</h4>
                  <span className={overviewStyles.cardBadge}>{project.category}</span>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section id="overview-messages" className={styles.dataSection}>
          <div className={styles.sectionHeader}>
            <h3>Messages non lus</h3>
            <button onClick={() => navigate('/admin/messages')} className={styles.viewAllButton}>Voir tout</button>
          </div>
          <ul className={overviewStyles.mobileList}>
            {messages.filter(m => !m.is_read).slice(0, 3).map(message => (
              <li key={message.id} className={overviewStyles.mobileCard}>
                <div className={overviewStyles.cardHeader}>
                  <h4 className={overviewStyles.cardTitle}>{message.expand?.sender?.name || 'N/A'}</h4>
                </div>
                <p className={overviewStyles.cardSubtitle}>{message.subject}</p>
              </li>
            ))}
            {messages.filter(m => !m.is_read).length === 0 && (
              <p style={{ color: 'var(--color-text-light)', fontStyle: 'italic', margin: 0 }}>Aucun message non lu.</p>
            )}
          </ul>
        </section>

        <section id="overview-reviews" className={styles.dataSection}>
          <div className={styles.sectionHeader}>
            <h3>Avis en attente</h3>
            <button onClick={() => navigate('/admin/reviews')} className={styles.viewAllButton}>Voir tout</button>
          </div>
          <ul className={overviewStyles.mobileList}>
            {reviews.filter(r => r.status === 'pending').slice(0, 3).map(review => (
              <li key={review.id} className={overviewStyles.mobileCard}>
                <div className={overviewStyles.cardHeader}>
                  <h4 className={overviewStyles.cardTitle}>{review.expand?.user?.name || 'N/A'}</h4>
                  <span style={{ fontSize: '0.9rem' }}>{'⭐'.repeat(review.rating)}</span>
                </div>
                <div className={overviewStyles.cardActions}>
                  <button className={overviewStyles.actionBtn}>Approuver</button>
                </div>
              </li>
            ))}
            {reviews.filter(r => r.status === 'pending').length === 0 && (
              <p style={{ color: 'var(--color-text-light)', fontStyle: 'italic', margin: 0 }}>Aucun avis en attente.</p>
            )}
          </ul>
        </section>

        <section id="overview-users" className={styles.dataSection}>
          <div className={styles.sectionHeader}>
            <h3>Utilisateurs Récents</h3>
            <button onClick={() => navigate('/admin/users')} className={styles.viewAllButton}>Voir tout</button>
          </div>
          <ul className={overviewStyles.mobileList}>
            {users.slice(0, 3).map(user => (
              <li key={user.id} className={overviewStyles.mobileCard}>
                <div className={overviewStyles.cardHeader}>
                  <h4 className={overviewStyles.cardTitle}>{user.name || 'N/A'}</h4>
                </div>
                <p className={overviewStyles.cardSubtitle}>{user.email}</p>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </>
  );
};

export default Overview;
